import type { DataManager } from '@syncfusion/ej2-data';
import { ODataV4Adaptor } from '@syncfusion/ej2-data';

/**
 * Injects a fresh `Authorization` header on each OData request (token refresh–safe).
 */
export class AuthorizedODataV4Adaptor extends ODataV4Adaptor {
  constructor(private readonly getAccessToken: () => string | undefined) {
    super();
  }

  public beforeSend(
    dm: DataManager,
    request: XMLHttpRequest,
    settings: unknown
  ): void {
    const token = this.getAccessToken();
    if (token) {
      request.setRequestHeader('Authorization', `Bearer ${token}`);
    }
    super.beforeSend(dm, request, settings as never);
  }
}
